import { NotificationService } from "./types";
import { useNotificationService } from "./useNotificationService";

export type { NotificationService };

export { useNotificationService };
